import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import { isDisplayableAsPercent } from "../../../modules/user_status_helper";
import ProgressBar from "../../progress_bar";
import classNames from "classnames";

const PROGRESS_BAR_WIDTH = 124;

export default GrComponentFactory.createClass({
  displayName: "UserStatusDetails",

  propTypes: {
    maxProgressValue: React.PropTypes.number,
    progressValue: React.PropTypes.number.isRequired,
    userStatusText: React.PropTypes.string,
    pageProgressText: React.PropTypes.string,
    readText: React.PropTypes.string,
  },

  getUserStatusHtml(){
    return { __html: this.props.userStatusText };
  },

  renderReadText() {
    return (
      this.props.readText ?
      <div className="gr-newsfeedItem__readCountText">
        {this.props.readText}
      </div>
        : null
    );
  },
  
  renderProgressBar() {
    if (isDisplayableAsPercent(this.props)) {
      return <ProgressBar
        max={this.props.maxProgressValue}
        width={PROGRESS_BAR_WIDTH}
        value={this.props.progressValue}
        progressText={this.props.pageProgressText}/>;
    } else {
      return <small>{this.props.pageProgressText}</small>;
    }
  },

  render() {
    const detailsClassName = classNames(
      { "u-paddingBottomSmall u-bottomGrayBorder": !this.props.userStatusText }
    );
    return <div className={detailsClassName}>
      {this.renderReadText()}
      {this.renderProgressBar()}
      {
        this.props.userStatusText ?
          <div className="gr-newsfeedItem__userStatusText" dangerouslySetInnerHTML={this.getUserStatusHtml()} /> : null
      }
    </div>;
  },
});
